const langs = [
  { code: "PL", name: "Polish", flag: "🇵🇱", note: "Waiting for you" },
  { code: "ES", name: "Spanish", flag: "🇪🇸", note: "Waiting for you" },
  { code: "DE", name: "German", flag: "🇩🇪", note: "Waiting for you" },
  { code: "TR", name: "Turkish", flag: "🇹🇷", note: "Ready next week" },
  { code: "FR", name: "French", flag: "🇫🇷", note: "Ready next week" },
  { code: "IT", name: "Italian", flag: "🇮🇹", note: "Ready next week" },
  { code: "PT", name: "Portuguese", flag: "🇵🇹", note: "Q3" },
  { code: "RU", name: "Russian", flag: "🇷🇺", note: "Q3" },
];

export const Languages = () => {
  return (
    <section
      id="languages"
      data-testid="languages-section"
      className="relative py-24 sm:py-28"
    >
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12 reveal">
          <div>
            <div className="mono-label mb-3">[ 05 · Catalogue ]</div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.02]">
              Built around{" "}
              <span className="text-[var(--vb-primary)]">your</span> target language.
            </h2>
          </div>

          <p className="max-w-md text-[var(--vb-muted)] text-base">
            {/* todo: Replace with actual email */}
            Your language not included? <a href="mailto:NOTANEMAIL" className="text-[var(--vb-primary)] hover:underline">Let me know</a>.
          </p>
        </div>

        <div
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 reveal"
          data-testid="languages-grid"
        >
          {langs.map((l, i) => (
            <div
              key={l.code}
              data-testid={`lang-${l.code}`}
              className="card-soft p-5 group hover:-translate-y-0.5 transition-transform cursor-pointer"
            >
              <div className="flex items-start justify-between mb-6">
                <img
                  src={`https://flagcdn.com/${l.code.toLowerCase()}.svg`}
                  alt={`${l.name} flag`}
                  className="w-8 h-5.5 object-cover rounded-[2px] shadow-sm border border-[var(--vb-border)] shrink-0"
                />
                <span className="mono-label">{l.code}</span>
              </div>
              <div className="flex items-baseline justify-between">
                <div className="font-display font-bold text-lg">{l.name}</div>
                <span
                  className={`text-[10px] font-mono ${l.note === "Day one"
                      ? "text-[var(--vb-known)]"
                      : "text-[var(--vb-muted)]"
                    }`}
                >
                  {l.note}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
